import { Box } from "@rebass/grid";
import {
  getLocale,
  getLocalizedText,
} from "@rentiohq/shared-frontend/dist/utils/i18n/i18n.utils";
import { ESpacings, Labelled } from "@rentiohq/web-shared/dist/components";
import { BaseDatePicker } from "@rentiohq/web-shared/dist/components/BaseDatePicker";
import { ts } from "@rentiohq/web-shared/dist/services";
import React from "react";
import ReactDatePicker from "react-datepicker";
import { getStartOfToday } from "utils/candidacyDeadline.utils";

interface IProps {
  value: Date | null;
  onChange: (value: Date | null) => void;
}

const DATE_FORMAT = "dd/MM/yyyy";

/**
 * The candidacy deadline in visit mode's invite dialogs (DEV-3531). The same
 * picker the forms use, outside a form: these dialogs are plain modals, and a
 * whole form for one optional date would be more machinery than the field.
 *
 * Not required, so the picker shows its clear button; an empty field sends
 * the invitation without a deadline.
 */
export const CandidacyDeadlineInput = (props: IProps) => {
  const { value, onChange } = props;

  const pickerRef = React.useRef<ReactDatePicker>(null);

  // Render
  return (
    <Box mt={ESpacings.base}>
      <Labelled
        label={getLocalizedText("application.candidacy_deadline")}
        helpText={getLocalizedText("application.candidacy_deadline.help")}
        optional={true}
      >
        <BaseDatePicker
          id="visit-mode-candidacy-deadline"
          ref={pickerRef}
          placeholderText={ts.datePlaceholder(DATE_FORMAT)}
          locale={getLocale()}
          selected={value}
          // The API refuses a day before today, so the picker does not offer one.
          minDate={getStartOfToday()}
          onChange={(input: Date | null) => onChange(input)}
          dateFormat={DATE_FORMAT}
          showTimeSelect={false}
          hideDayPicker={false}
          hasError={false}
          isDisabled={false}
          required={false}
          inverseYears={false}
          handleClear={() => onChange(null)}
          handleIconClick={() => pickerRef.current?.setOpen(true)}
        />
      </Labelled>
    </Box>
  );
};
